import React, {Component} from 'react';
import {
    View,
    TextInput,
    BackHandler,
    Alert,
    Image,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    ImageBackground,
    FlatList,
    StatusBar,
    Text
} from "react-native"

import {verticalScale, moderateScale, scale} from "../../../../tools/Scaling";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import Colors from "../../../../tools/Colors";
import HMTextView from "../../../../customviews/HMTextView";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import HMActionBar from "../../../../customviews/HMActionBar";
import i18n from "../../../../I18n/i18n";
import {AsyngStorageClass} from "../../../../tools/AsyngStorageClass";
import {Tools} from "../../../../tools/Tools";
import {typeExport} from "../../../../redux/store/type";
import store from "../../../../redux/store";
import HMAlert from "../../../../customviews/HMAlert";
import FloatingLabelInput from "../../../../customviews/input/floatLabelInput";
import * as NavigationService from "../../../../redux/NavigationService";
import {serviceActionListFilter} from "../../main/applay/action/ActionGalleryServiceScreen";
import HMIcon from "../../../../customviews/HMIcon";

export default class LoginEnterPhoneCodeScreen extends Component {

    constructor(props) {
        super(props)
        global.registerLogin = false;
        this.state = {
            // mobile: this.props.route.params.mobile
            mobile: !global._mobile || global._mobile === "" || global._mobile == null ? "" : global._mobile,
            password: '',
            Once: false
        }
        props.callServiceRefresh();
    }

    hiddenModal() {
        this.setState({
                visibleModal: ''
            },
            () => {
            })
    }


    async setToken(token) {
        await AsyngStorageClass.setToken(token);

    }

    componentWillReceiveProps(propss) {

        if (propss.results != null) {
            //  this.loadingButton.showLoading(false);

            if (propss.results.success == true) {
                //   Actions.replace("code");
                // Actions.code({ mobile: this.state.mobile, result_extra: propss.results, type_login: this.props.type_login ,AdvertisingChildlist:this.props.AdvertisingChildlist});
                // this.props.navigation.navigate("EnterCodeScreen", {
                //     mobile: this.state.mobile,
                //     result_extra: propss.results,
                //     //  type_login: this.props.route.params.type_login
                //     /*, AdvertisingChildlist: this.props.route.params.AdvertisingChildlist*/
                // });

                /*

                                if (propss.results.login_app == 0) {
                                    this.setToken(propss.results.access_token)
                                    NavigationService.resetTo('SplashScreen');
                                }
                                else {
                                    NavigationService.resetTo('ChangePassScreen', {token: propss.results.access_token});
                                }
                */


                //  NavigationService.resetTo('ChangePassScreen',{token:propss.results.access_token });
                //   this.setToken(propss.results.access_token)
                //   NavigationService.resetTo('SplashScreen');
                // this.props.navigation.navigate("EnterCodeScreen", {
                //     mobile: this.state.mobile,
                //     result_extra: propss.results,
                //     //  type_login: this.props.route.params.type_login
                //     /*, AdvertisingChildlist: this.props.route.params.AdvertisingChildlist*/
                // });
            } else {
                alert(propss.results.message)

            }
        }

    }

    getData() {

        if (this.props.DataSplashScreen.Connection) {
            let {mobile, password} = this.state;
            global._mobile = mobile
            let checkTypeLogin = this.props.route.params && this.props.route.params.type == "forgot_my_password";
            this.setState({
                    Once: true
                },
                () => {


                    let paramss = {
                        "_operation": typeExport._Registration,
                        "lang": i18n.locale,
                        "mode": typeExport._sendCodeMode,
                        "forgotmode": checkTypeLogin && !global.registerLogin ? "1" : "0",
                        "mobile": mobile,
                    };


                    this.props.callService(
                        typeExport.urlGetLoginEnterPhoneCodeScreen,
                        paramss,
                        typeExport.TypegetDataLoginEnterPhoneCodeScreen,
                        "POST",
                        this.state
                    );
                }
            )

        } else
            this.props.callServiceError("offline")


    }

    checkMobile(text) {

        text = Tools.persianToEnglish(text)

        const reg = /^([0]|| [98])?09\d{9}$/;
        if (reg.test(text) === false) {
            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.checkMobile'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        }
                    },
                ],
                {cancelable: true}
            )
            //alert("شماره را به صورت ۱۱ رقمی و معتبر وارد نمایید")

        } else {
            this.getData()
            /*  if (Tools.CheckValue(this.state.password) === null || this.state.password.trim().length <= 3) {
                  HMAlert(
                      i18n.t('constant.message'),
                      i18n.t('constant.checkPassword'),
                      [
                          // {text: 'Ask me later', onPress: () => {}},
                          // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                          {text: i18n.t('constant.ok'), onPress: () => {}},
                      ],
                      {cancelable: true}
                  )
                  //alert("شماره را به صورت ۱۱ رقمی و معتبر وارد نمایید")

              } else {
                  //  this.loadingButton.showLoading(true);
                  this.setState({
                          // mobile: text,
                      }
                      ,
                      () => {
                          this.getData()
                      }
                  );

              }*/

        }

    }

    componentDidMount() {
        let City = this.props.DataSplashScreen?.City;
        if (!Tools.CheckValue(City) && (typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) {
            this.setState({
                checkCountRequest: this.state.checkCountRequest + 1
            })
            // setTimeout(function () {
            //     NavigationService.navigateParams("ListCityScreen");
            //     }.bind(this), 2000
            // );
            NavigationService.navigateParams("ListCityScreen");

        }

        this.props.navigation.addListener('focus', async () => {


                if (this.state.checkCountRequest > 0) {
                    let City = this.props.DataSplashScreen?.City;

                    //if (!this.props.DataSplashScreen?.City) {
                    if (!Tools.CheckValue(City) && (typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) {
                        //  NavigationService.navigateParams("ListCityScreen");
                        NavigationService.Pop();

                    }
                    else {

                    }
                }

            }
        )

        // BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    handleBackPress = () => {
        this.goBack(); // works best when the goBack is async
        return true;
    }

    // goBack() {
    //
    //     this.props.navigation.pop();
    //
    //     // switch (this.props.route.params.type_login) {
    //     //
    //     //     case "fav":
    //     //         this.props.navigation.navigate("MainScreen");
    //     //         break;
    //     //
    //     // }
    //
    // }

    render() {
        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2)
        let City = this.props.DataSplashScreen?.City;

        return (
            <View style={{position: 'relative', flex: 1}}>


                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <View style={{flex: 1,}}>
                            <HMActionBar
                                props={this.props} statusBarTransparent
                                text={i18n.t('login.title')}

                                //  text={i18n.t('constant.Information')}
                                menu={!checkLogin}
                                back
                                headerVisibility more_menu
                                onBackPress={() => this.props.navigation.pop()}
                                ViewCenter={
                                    (typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest") ?
                                        () => {
                                            return <View style={{flexDirection: "row"}}>

                                                <HMTextView
                                                    numberOfLines={1}
                                                    text={i18n.t('login.title')}
                                                    type="bold"
                                                    style={{
                                                        alignSelf: "center",
                                                        color: Colors.light,
                                                        fontSize: moderateScale(16),
                                                    }}
                                                />

                                                <HMTextView
                                                    numberOfLines={1}
                                                    text={City ? ` (${City.name}) ` : ""}
                                                    type="bold"
                                                    style={{
                                                        alignSelf: "center",
                                                        color: Colors.light,
                                                        fontSize: moderateScale(16),
                                                        marginHorizontal: moderateScale(8)
                                                    }}
                                                />

                                                <HMIcon
                                                    type={"AntDesign"}
                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                    name={"sync"}
                                                    //resizeMode="stretch"
                                                    style={[{fontSize: moderateScale(24)}, {
                                                        color: Colors.white
                                                    }]}
                                                    onPress={() => {
                                                        NavigationService.navigateParams("ListCityScreen")
                                                    }}
                                                />
                                            </View>
                                        }
                                        :
                                        null
                                }
                            />
                            {/*<Image source={require("../../assets/img/logo.png")}*/}
                            {/*style={{*/}
                            {/*width: moderateScale(150),*/}
                            {/*height: moderateScale(100),*/}
                            {/*alignSelf: 'center',*/}
                            {/*marginBottom: moderateScale(18)*/}
                            {/*}}/>*/}
                            <View style={{
                                width: '100%',
                                flexDirection: 'row',
                                backgroundColor: Colors.white,
                                padding: moderateScale(10),
                                justifyContent: 'center',
                                alignItems: 'center'
                                // marginBottom: moderateScale(8),
                            }}>
                                <HMTextView text={i18n.t('constant.descLogin')} type="bold" style={{
                                    alignSelf: "center",
                                    color: Colors.colorDark,
                                    fontSize: moderateScale(14),
                                    textAlign: 'center'

                                }}/>
                            </View>


                            {/*  <HMTextInput value={this.state.mobile} keyboardType="numeric"
                                         onChangeText={text => this._changeText(text)} autoFocus
                                         placeholder={i18n.t('constant.phoneNumber')}
                                         NoShowPlaceholder
                                         _width={'85%'}
                                         icon={"md-person"}
                                         style={{


                                             fontSize: moderateScale(14),
                                             // marginTop: moderateScale(6)
                                         }} underlineColorAndroid="transparent" maxLength={11}/>*/}

                            {/*     <HMTextInputEfects
                                value={this.state.mobile}

                                type={"Fumi"}
                                label={i18n.t('constant.phoneNumber')}
                                descLabel={i18n.t('constant.phoneNumber') + ` ( ${i18n.locale == "fa" ? "*********09" : "09*********"} ) `}
                                //placeholder={i18n.t('constant.phoneNumber')+" (09*********) "}
                                onChangeText={text => this._changeText(text)}
                                iconClass={"FontAwesome"}
                                iconName={'phone'}
                                keyboardType="numeric"
                                styleRoot={{
                                    width: "100%", alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            />
*/}

                            <FloatingLabelInput
                                label={i18n.t('constant.phoneNumber')}
                                value={this.state.mobile}
                                staticLabel
                                hintTextColor={'#aaa'}
                                styleRoot={{marginVertical: moderateScale(8), width: "93%", alignSelf: 'center',}}
                                //mask="99 (99) 99999-9999"
                                hint={i18n.t('constant.phoneNumber') + ` ( ${i18n.locale == "fa" ? "*********09" : "09*********"} ) `}
                                containerStyles={{
                                    borderWidth: moderateScale(2),
                                    paddingHorizontal: moderateScale(10),
                                    backgroundColor: '#fff',
                                    borderColor: 'blue',
                                    borderRadius: moderateScale(8),
                                }}
                                customLabelStyles={{
                                    colorFocused: 'red',
                                    fontSizeFocused: moderateScale(12),
                                }}
                                labelStyles={{
                                    backgroundColor: '#fff',
                                    paddingHorizontal: moderateScale(5),
                                }}
                                inputStyles={{
                                    color: 'blue',
                                    paddingHorizontal: moderateScale(2),
                                    marginVertical: moderateScale(2),
                                    height: moderateScale(48),
                                    outlineColor: Colors.transparent
                                }}
                                onChangeText={text => this._changeText(text)}
                                onSubmitEditing={() => this.checkMobile(this.state.mobile)}
                            />
                            {/*    <HMTextInputEfects
                                type={"Fumi"}
                                label={i18n.t('constant.password')}
                                onChangeText={text => {
                                    this.setState({password: text})
                                }}
                                iconClass={"FontAwesome"}
                                iconName={'lock'}
                                secureTextEntry={true}
                            />*/}
                            {/*      <Fumi
                                onChangeText={text => this._changeText(text)}
                                label={i18n.t('constant.phoneNumber')}
                                iconClass={"FontAwesome"}
                                iconName={'user'}
                                iconColor={colorSecondPrimary}
                                iconSize={20}
                                iconWidth={40}
                                inputPadding={16}
                                style={{
                                  //  marginVertical:moderateScale(6),
                                    marginTop:moderateScale(18),
                                    width: "85%",
                                  //  height: moderateScale(20),
                                    alignSelf: 'center',
                                }}
                            />


                            <Fumi
                                onChangeText={text => {
                                    this.setState({password: text})
                                }}
                                label={i18n.t('constant.password')}
                                iconClass={"FontAwesome"}
                                iconName={'lock'}
                                iconColor={colorSecondPrimary}
                                secureTextEntry={true}
                                iconSize={20}
                                iconWidth={40}
                                inputPadding={16}
                                style={{
                                    marginVertical:moderateScale(6),
                                    width: "85%",
                                  //  height: moderateScale(40),
                                    alignSelf: 'center',


                                }}
                            />*/}

                            {/*    <HMTextInput
                                value={this.state.password}
                                //keyboardType="numeric"
                                onChangeText={text => {
                                    this.setState({password: text})
                                }}
                                icon={"md-key"}
                                autoFocus
                                _width={'85%'}
                                placeholder={i18n.t('constant.password')}
                                NoShowPlaceholder
                                style={{
                                    // marginStart: moderateScale(10),
                                    fontSize: moderateScale(14),
                                    //  marginTop: moderateScale(6)
                                }} underlineColorAndroid="transparent" maxLength={11}/>*/}


                            {/*<AnimateLoadingButton*/}
                            {/*ref={c => (this.loadingButton = c)}*/}
                            {/*width={moderateScale(300)}*/}
                            {/*height={verticalScale(50)}*/}
                            {/*title="ارسال"*/}
                            {/*titleFontFamily={Constants.regularFontName}*/}
                            {/*containerStyle={{marginTop: moderateScale(20)}}*/}
                            {/*titleFontSize={moderateScale(16)}*/}
                            {/*titleColor="rgb(255,255,255)"*/}
                            {/*backgroundColor={Colors.colorPrimary}*/}
                            {/*borderRadius={4}*/}
                            {/*onPress={() => this.checkMobile(this.state.mobile)}*/}
                            {/*/>*/}

                            <TouchableOpacity style={{
                                backgroundColor: Colors.colorPrimary,
                                width: "93%",
                                height: moderateScale(40),
                                alignSelf: 'center',
                                alignItems: "center",
                                justifyContent: "center",
                                marginTop: moderateScale(8),
                                borderRadius: moderateScale(6)
                                // borderRadius:moderateScale(2)
                            }}
                                              onPress={() => this.checkMobile(this.state.mobile)}
                            >
                                <View style={{flexDirection: "row", alignItems: "center", justifyContent: "center"}}>
                                    <HMTextView type={"bold"} text={i18n.t('constant.signIn')} style={{
                                        color: "white",
                                        fontSize: moderateScale(16),
                                        marginEnd: moderateScale(10)
                                    }}/>

                                </View>
                            </TouchableOpacity>

                            {/*<View style={{flex:1}}/>*/}
                            {/*<View style={{*/}
                            {/*width: '100%', marginTop: moderateScale(10),*/}
                            {/*backgroundColor: Colors.light*/}
                            {/*}}>*/}

                            {/*<View style={{*/}
                            {/*flexDirection: 'row',*/}
                            {/*alignSelf: 'center',*/}
                            {/*paddingHorizontal: moderateScale(20),*/}
                            {/*paddingVertical: moderateScale(8),*/}
                            {/*backgroundColor: Colors.light*/}
                            {/*}}>*/}

                            {/*<HMTextView type={"bold"} text={i18n.t('constant.language')} style={{*/}
                            {/*color: Colors.blackLight,*/}
                            {/*alignSelf: 'center',*/}
                            {/*fontSize: moderateScale(16),*/}
                            {/*// marginEnd: moderateScale(10),*/}
                            {/*marginBottom: moderateScale(3)*/}
                            {/*}}/>*/}

                            {/*<View style={{flex: 1}}/>*/}
                            {/*<TouchableOpacity*/}
                            {/*style={{*/}
                            {/*alignSelf: 'center',*/}
                            {/*justifyContent: 'center',*/}
                            {/*alignItems: 'center',*/}
                            {/*// borderRadius: moderateScale(24),*/}
                            {/*// borderWidth: moderateScale(1),*/}
                            {/*// borderColor: colorPrimary,*/}
                            {/*// width: moderateScale(48),*/}
                            {/*//  height: moderateScale(48),*/}
                            {/*//marginTop: moderateScale(4),*/}
                            {/*}}*/}
                            {/*onPress={() => {*/}
                            {/*if (i18n.locale != 'en')*/}
                            {/*Tools.changeAppLang('en');*/}
                            {/*}}*/}
                            {/*>*/}


                            {/*/!*<Image*!/*/}
                            {/*/!*source={require("../../assets/img/Englis.jpg")}*!/*/}
                            {/*/!*style={{*!/*/}
                            {/*/!*width: moderateScale(48),*!/*/}
                            {/*/!*height: moderateScale(48),*!/*/}
                            {/*/!*borderRadius: moderateScale(24)*!/*/}
                            {/*/!*}}/>*!/*/}
                            {/*<HMTextView type={"bold"} text={"English"} style={{*/}
                            {/*color: i18n.locale == 'en' ? Colors.colorPrimary : Colors.blackLight,*/}
                            {/*alignSelf: 'center',*/}
                            {/*fontSize: moderateScale(14),*/}
                            {/*// marginEnd: moderateScale(10),*/}
                            {/*//  marginBottom: moderateScale(3)*/}
                            {/*}}/>*/}

                            {/*</TouchableOpacity>*/}
                            {/*<View style={{width: moderateScale(16)}}/>*/}
                            {/*<TouchableOpacity*/}
                            {/*style={{*/}
                            {/*alignSelf: 'center',*/}
                            {/*justifyContent: 'center',*/}
                            {/*alignItems: 'center',*/}
                            {/*//  borderRadius: moderateScale(24),*/}
                            {/*//   borderWidth: moderateScale(1),*/}
                            {/*//  borderColor: colorPrimary,*/}
                            {/*//  width: moderateScale(48),*/}
                            {/*//  height: moderateScale(48),*/}
                            {/*//marginTop: moderateScale(4),*/}
                            {/*}}*/}
                            {/*onPress={() => {*/}
                            {/*if (i18n.locale != 'ar')*/}
                            {/*Tools.changeAppLang('ar');*/}
                            {/*}}*/}
                            {/*>*/}


                            {/*/!*<Image*!/*/}
                            {/*/!*source={require("../../assets/img/UAE.jpeg")}*!/*/}
                            {/*/!*style={{*!/*/}
                            {/*/!*width: moderateScale(48),*!/*/}
                            {/*/!*height: moderateScale(48),*!/*/}
                            {/*/!*borderRadius: moderateScale(24)*!/*/}
                            {/*/!*}}/>*!/*/}

                            {/*<HMTextView type={"bold"} text={"العربیه"} style={{*/}
                            {/*color: i18n.locale == 'ar' ? Colors.colorPrimary : Colors.blackLight,*/}
                            {/*alignSelf: 'center',*/}
                            {/*fontSize: moderateScale(14),*/}
                            {/*// marginEnd: moderateScale(10),*/}
                            {/*//  marginBottom: moderateScale(3)*/}
                            {/*}}/>*/}

                            {/*</TouchableOpacity>*/}

                            {/*</View>*/}
                            {/*<View style={{*/}
                            {/*width: Contants.WIDTH,*/}
                            {/*height: moderateScale(1),*/}
                            {/*backgroundColor: Colors.gray,*/}
                            {/*shadowColor: '#000000',*/}
                            {/*shadowOffset: {*/}
                            {/*width: 0,*/}
                            {/*height: moderateScale(2)*/}
                            {/*},*/}
                            {/*shadowRadius: moderateScale(5),*/}
                            {/*shadowOpacity: 1.0,*/}
                            {/*marginVertical: moderateScale(10)*/}
                            {/*}}/>*/}


                            {/*<TouchableOpacity*/}
                            {/*style={{*/}
                            {/*alignSelf: 'center',*/}
                            {/*justifyContent: 'center',*/}
                            {/*alignItems: 'center',*/}
                            {/*width: Contants.WIDTH,*/}
                            {/*//backgroundColor:Colors.red*/}

                            {/*}}*/}
                            {/*onPress={() => {*/}
                            {/*this.setState({*/}
                            {/*visibleModal: 'contact'*/}
                            {/*},*/}
                            {/*() => {*/}
                            {/*})*/}
                            {/*}}*/}
                            {/*>*/}
                            {/*<HMTextView type={"bold"} text={i18n.t('constant.callUs')} style={{*/}
                            {/*color: Colors.black,*/}
                            {/*alignSelf: 'center',*/}
                            {/*fontSize: moderateScale(16),*/}
                            {/*marginEnd: moderateScale(10),*/}
                            {/*marginBottom: moderateScale(8),*/}
                            {/*marginTop: moderateScale(8),*/}
                            {/*}}/>*/}
                            {/*</TouchableOpacity>*/}
                            {/*</View>*/}


                        </View>


                        {
                            this.props.NoInternetDialog ?
                                <DialogConnectionCustomize
                                    onPress={() => this.checkMobile(this.state.mobile)}
                                />
                                :
                                null
                        }
                        {
                            this.props.isLoading ?
                                <DialogLoadingCustomize/>
                                : null
                        }

                        {/*            <HMModal
                            isVisible={this.state.visibleModal === 'contact'}
                            backdropColor={Colors.gray}
                            backdropOpacity={0.8}
                            animationIn="zoomInDown"
                            animationOut="zoomOutUp"
                            animationInTiming={600}
                            animationOutTiming={600}
                            backdropTransitionInTiming={600}
                            backdropTransitionOutTiming={600}
                            //style={{height: '60%'}}
                            onBackdropPress={() => this.hiddenModal()}
                        >

                            <View style={{backgroundColor: Colors.white, padding: moderateScale(10)}}>

                                <HMTextView type={"bold"} text={i18n.t('constant.callUs')} style={{
                                    color: Colors.black,
                                    // alignSelf: 'center',
                                    fontSize: moderateScale(16),
                                    marginEnd: moderateScale(10),
                                    marginBottom: moderateScale(8),
                                    marginTop: moderateScale(8),
                                }}/>
                                <View style={{
                                    width: '100%',
                                    height: moderateScale(1),
                                    backgroundColor: Colors.graylight,
                                    shadowColor: '#000000',
                                    shadowOffset: {
                                        width: 0,
                                        height: moderateScale(2)
                                    },
                                    shadowRadius: moderateScale(5),
                                    shadowOpacity: 1.0
                                }}/>
                                <HMItemFinalRequest
                                    //detail
                                    // icon={"md-add"}
                                    detail
                                    Notline
                                    text={"04-5570768"}
                                    title={i18n.t('constant.phone')}
                                    navigateParams={() => {
                                        //  this.props.navigation.navigate("ProfileStack");

                                    }}/>


                                <HMItemFinalRequest
                                    //detail
                                    // icon={"md-add"}
                                    //  detail
                                    Notline
                                    text={"info@appsmda.com"}
                                    title={i18n.t('constant.email')}
                                    navigateParams={() => {
                                        //  this.props.navigation.navigate("ProfileStack");

                                    }}/>
                                <HMItemFinalRequest
                                    //detail
                                    // icon={"md-add"}
                                    //   detail
                                    Notline
                                    text={i18n.t('constant.addressDesc')}
                                    title={
                                        i18n.t('constant.address')

                                    }
                                    navigateParams={() => {
                                        //  this.props.navigation.navigate("ProfileStack");

                                    }}/>

                                <HMItemFinalRequest
                                    detail
                                    link
                                    Notline
                                    text={"http://appsmda.com/"}
                                    title={i18n.t('constant.website')}
                                    navigateParams={() => {
                                        //  this.props.navigation.navigate("ProfileStack");

                                    }}/>


                            </View>
                        </HMModal>*/}
                    </KeyboardAvoidingView>
                </View>
            </View>

        );
    }

    _changeText(text) {
        this.setState({mobile: text});
    }
}
